export default "__VITE_ASSET__By7RpPsc__"